import { Card, CardContent, Avatar, Box, Stack, Typography } from "@mui/material";
import { useLogin } from "../context/Login/LoginContext";
import NotFound from "./NotFound";

const Profile = () => {
    const { user } = useLogin();
    if (!user) return <NotFound />;

    return (
        <Box sx={{ maxWidth: 600, mx: "auto", mt: 4 }}>
            <Card>
                <CardContent sx={{ minWidth: 300 }}>
                    <Stack spacing={3} alignItems="center">
                        <Avatar
                            src={user.image}
                            alt={user.name}
                            sx={{ width: 120, height: 120 }}
                        />

                        <Stack spacing={1} alignItems="center">
                            <Typography variant="h5">
                                {user.name}
                            </Typography>
                            <Typography variant="subtitle1" color="text.secondary">
                                {user.email}
                            </Typography>
                        </Stack>

                        {(user.role || user.status || user.timezone) && (
                            <Stack spacing={2} sx={{ width: "100%" }}>
                                {user.role && (
                                    <Box>
                                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                            Role
                                        </Typography>
                                        <Typography variant="body1">
                                            {user.role}
                                        </Typography>
                                    </Box>
                                )}

                                {user.status && (
                                    <Box>
                                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                            Status
                                        </Typography>
                                        <Typography variant="body1">
                                            {user.status}
                                        </Typography>
                                    </Box>
                                )}

                                {user.timezone && (
                                    <Box>
                                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                            Timezone
                                        </Typography>
                                        <Typography variant="body1">
                                            {user.timezone}
                                        </Typography>
                                    </Box>
                                )}
                            </Stack>
                        )}
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
}

export default Profile;